#import "../fragments/domain-fragment.graphql"

mutation DeleteDomain($domain: DomainDeleteInput!) {
    domainDelete(input: $domain) {
        domain {
            ...DomainFragment
        }
    }
}
